export enum AppName {
  IOT4BOS = 'IOT4BOS',
  KERCOM = 'KERCOM connector',
  DALIA = 'DALIA connector',
  XMQTT = 'XFLOW connector',
  OYAN = 'OYAN',
  BAM = 'BAM connector',
  NTE = 'NTE connector',
  MONITOR_MY_PLANT = 'Monitor My Plant',
}
